import { getIndivCookie } from 'components/Cookies/cookieHandlers';
import React, { createContext, FunctionComponent, useMemo, useState } from 'react';
import { TSessionTimerContextProvider, TSessionTimerContext } from './SessionTimerContextTypes';

export const SessionTimerContext = createContext<TSessionTimerContext | null>(null);
export const SessionTimerContextProvider: FunctionComponent<TSessionTimerContextProvider> = ({
  children,
}) => {
  const [sessionExpiryTime, setSessionExpiryTime] = useState(getIndivCookie('cExpiryTime'));

  const providerValue = useMemo(
    () => ({
      sessionExpiryTime,
      setSessionExpiryTime,
    }),
    [sessionExpiryTime],
  );
  return (
    <SessionTimerContext.Provider value={providerValue}>{children}</SessionTimerContext.Provider>
  );
};
